import { lazy } from 'react';

import type { RouteObject } from 'react-router-dom';

const CreateEditTemplateDrawer = lazy(
  () =>
    import('@/components/drawer/createEditTemplate/CreateEditTemplateDrawer'),
);

const TemplateLandingPage = lazy(
  () => import('@/pages/Configuration/Templates/TemplateLandingPage'),
);

const DefectLifeCycleDrawer = lazy(
  () =>
    import('@/pages/Configuration/Templates/components/drawers/DefectLifeCycle/DefectLifeCycleDrawer'),
);
const ManualTestCaseLifeCycleDrawer = lazy(
  () =>
    import('@/pages/Configuration/Templates/components/drawers/DefectLifeCycle/ManualTestCaseLifeCycleDrawer'),
);
const CreateDefectTemplateDrawer = lazy(
  () =>
    import('@/pages/Configuration/Templates/components/drawers/defectTemplateDrawer/CreateDefectTemplateDrawer'),
);
const TemplateDetailsDrawer = lazy(
  () =>
    import('@/pages/Configuration/Templates/components/drawers/details/TemplateDetailsDrawer'),
);

export const TemplateRoutes: RouteObject[] = [
  {
    path: '/configuration/templates/*',
    element: <TemplateLandingPage />,
    children: [
      {
        path: 'defectLifecycleTemplate/details-drawer/:templateName',
        element: <DefectLifeCycleDrawer />,
      },
      {
        path: 'mtcLifecycleTemplate/details-drawer/:templateName',
        element: <ManualTestCaseLifeCycleDrawer />,
      },
      {
        path: ':templateType/template-details-drawer/:templateName',
        element: <TemplateDetailsDrawer />,
      },
      {
        path: 'scriptTemplate/create-edit-template/:templateName/:templateId',
        element: <CreateEditTemplateDrawer />,
      },
      {
        path: 'scriptTemplate/create-edit-template',
        element: <CreateEditTemplateDrawer />,
      },
      {
        path: 'defectDetailsTemplate/create-edit-template/:templateName/:templateId',
        element: <CreateDefectTemplateDrawer />,
      },
      {
        path: 'defectDetailsTemplate/create-edit-template',
        element: <CreateDefectTemplateDrawer />,
      },
    ],
  },
];
